import React from "react";
import { Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const PopupFeedbackSuccess = ({}) => {
  return (
    <Grid container style={{ backgroundColor: "#fff" }}>
      <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
        <Grid xs={1} item>
          {" "}
          <div className="icon-check-success" />
        </Grid>
        <Grid xs={11} item>
          {" "}
          <Typography
            className="color-primary-dark"
            style={{ marginLeft: "10px", textAlign: "center" }}
          >
            Salvataggio avvenuto con successo
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PopupFeedbackSuccess;
